/**
 * Pneus no portal — leitura da fonte canônica (Finatto). Nenhum cadastro aqui.
 * "Inspeção atrasada" não é exibida como zero: a integração não envia a data.
 */
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import type { MaintenancePortalTiresDto } from "@bi/types";
import { api } from "../../lib/api";
import { EmptyState } from "../../components/EmptyState";
import { IconTire } from "../../components/icons";
import { portalPaths } from "../../features/portal/portal-nav";

export function PortalTiresPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["maintenance", "portal", "tires"],
    queryFn: () => api.get<MaintenancePortalTiresDto>("/maintenance/portal/tires"),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h1 className="text-lg font-semibold text-gray-900">Pneus</h1>
          <p className="text-sm text-gray-500">Abaixo da milimetragem de segurança (fonte Finatto).</p>
        </div>
        <Link className="btn-primary flex-shrink-0" to="/app/frota/pneus/inspecao">Inspecionar</Link>
      </div>

      {isLoading ? (
        <p className="text-sm text-gray-500">Carregando…</p>
      ) : (data?.critical.length ?? 0) === 0 ? (
        <div className="card">
          <EmptyState icon={<IconTire className="w-6 h-6" />} title="Nenhum pneu crítico"
            description="Nenhum pneu ativo está abaixo do sulco de segurança." />
        </div>
      ) : (
        <div className="card divide-y divide-surface-border">
          {data!.critical.map((t) => (
            <div key={t.id} className="px-4 py-3 flex items-center gap-3 min-h-[56px]">
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-gray-900">
                  Fogo {t.fireNumber ?? "—"}
                  {t.plate && (
                    <>
                      {" · "}
                      <Link className="font-mono text-tm-700 hover:underline" to={portalPaths.vehicle(t.plate)}>{t.plate}</Link>
                    </>
                  )}
                </p>
                <p className="text-xs text-gray-500">{[t.brand, t.size].filter(Boolean).join(" · ") || "sem marca/medida"}</p>
              </div>
              <span className="badge-red flex-shrink-0">{t.currentMm.toFixed(1)} mm / mín {t.safetyMm.toFixed(1)}</span>
            </div>
          ))}
        </div>
      )}

      <p className="text-xs text-gray-400">{data?.inspection.reason}</p>
      <p className="text-xs text-gray-400">
        Só os pneus com placa na Finatto aparecem ligados a um veículo. O vínculo de carreta está pendente na integração.
      </p>
    </div>
  );
}
